// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"319":"10d477c8","618":"e29bc919"}[chunkId] + ".css";
};